
import Vue from 'vue'
import Router from 'vue-router'
import Util from '../util'

//PAGES
import DefaultTemplate from '../pages/DefaultTemplate'
import Admin from '../components/Admin'
import Login from '../pages/Login'
import Consulta from '../components/Consulta'

Vue.use(Router)

const route = (path,name,meta, component, props) => {
  return {
    path,
    name,
    meta,
    component: () => import(`../components/${component}`),
    props
  }
}

const routeWithChildren = (path,name,meta, component, redirect, children) => {
  return {
    path,
    name,
    meta,
    component: () => import(`../components/${component}`),
    redirect,
    children
  }
}

const router = new Router({
  routes: [
    {
      path: '/',
      component: DefaultTemplate,
      redirect: 'admin/comprobantes',
      children:[
        {
          path: 'admin',
          component: Admin,
          redirect:'admin/comprobantes',
          children: [
            routeWithChildren('comprobantes','admin.comprobantes', {requiresAuth: true, titulo:'Comprobantes'}, 'admin/Comprobantes','/admin/comprobantes/ver-comprobantes',
                    [
                      route('ver-comprobantes','admin.comprobantes.ver-comprobantes', {requiresAuth: true, titulo: 'Comprobantes electrónicos'}, 'admin/comprobantes/VerComprobantes'),
                      route('emision-masiva','admin.comprobantes.emision-masiva', {requiresAuth: true, titulo: 'Emision masiva'}, 'admin/comprobantes/CargaMasiva'),
                      route('emitir-factura','admin.comprobantes.emitir-factura', {requiresAuth: true, titulo: 'Emitir factura electrónica'}, 'admin/comprobantes/EmitirFactura', {isEdit: false}),
                      //emitir factura x guia---------------
                      route('emitir-factura-guia/:idGuia?','admin.comprobantes.emitir-factura-guia', {requiresAuth: true, titulo: 'Emitir factura electrónica'}, 'admin/comprobantes/EmitirFactura', {isEdit: false}),
                      //------------------------------------
                      //emitir boleta x guia---------------
                      route('emitir-boleta-guia/:idGuia?','admin.comprobantes.emitir-boleta-guia', {requiresAuth: true, titulo: 'Emitir boleta electrónica'}, 'admin/comprobantes/EmitirBoleta', {isEdit: false}),
                      //------------------------------------
                      route('emitir-boleta','admin.comprobantes.emitir-boleta', {requiresAuth: true, titulo: 'Emitir boleta electrónica'}, 'admin/comprobantes/EmitirBoleta', {isEdit: false}),
                      route('emitir-nota-credito/:id?','admin.comprobantes.emitir-nota-credito', {requiresAuth: true, titulo: 'Emitir nota de crédito electrónica'}, 'admin/comprobantes/EmitirNotaDeCredito', {isEdit: false}),
                      route('emitir-nota-debito/:id?','admin.comprobantes.emitir-nota-debito', {requiresAuth: true, titulo: 'Emitir nota de débito electrónica'}, 'admin/comprobantes/EmitirNotaDeDebito', {isEdit: false}),

                      //EDITAR COMPROBANTE
                      route('editar-factura/:idEdit','admin.comprobantes.editar-factura', {requiresAuth: true, titulo: 'Editar factura electrónica'}, 'admin/comprobantes/EmitirFactura', {isEdit: true}),
                      route('editar-boleta/:idEdit','admin.comprobantes.editar-boleta', {requiresAuth: true, titulo: 'Editar boleta electrónica'}, 'admin/comprobantes/EmitirBoleta', {isEdit: true}),
                      route('editar-nota-credito/:idEdit','admin.comprobantes.editar-nota-credito', {requiresAuth: true, titulo: 'Editar nota de crédito electrónica'}, 'admin/comprobantes/EmitirNotaDeCredito', {isEdit: true}),
                      route('editar-nota-debito/:idEdit','admin.comprobantes.editar-nota-debito', {requiresAuth: true, titulo: 'Editar nota de débito electrónica'}, 'admin/comprobantes/EmitirNotaDeDebito',{isEdit: true}),
                      
                      //emitir boleta x cotizacion
                      route('emitir-boleta-coti/:idCoti?', 'admin.comprobantes.emitir-boleta-coti', {requiresAuth: true, titulo: 'Emitir boleta electrónica'}, 'admin/comprobantes/EmitirBoleta', {isEdit: false}),
                      route('emitir-factura-coti/:idCoti?', 'admin.comprobantes.emitir-factura-coti', {requiresAuth: true, titulo: 'Emitir factura electrónica'}, 'admin/comprobantes/EmitirFactura', {isEdit: false})
                    ]
              ),
            routeWithChildren('guiaRemision','admin.guiaRemision', {requiresAuth: true, titulo:'Guías de remisión'}, 'admin/GuiaRemision','/admin/guiaRemision/ver-guias',
                    [
                      route('ver-guias','admin.guiaRemision.ver-guias', {requiresAuth: true, titulo: 'Guías de Remisión electrónicos'}, 'admin/guiaRemision/VerGuias'),
                      route('guia-transportista','admin.guiaRemision.guia-transportista', {requiresAuth: true, titulo: 'Emitir Guía de Remisión Transportista'}, 'admin/guiaRemision/GuiaTransportista'),
                      route('guia-remitente', 'admin.guiaRemision.guia-remitente', { requiresAuth: true, titulo: 'Emitir Guía de Remisión Remitente' }, 'admin/guiaRemision/GuiaRemitente'),
                      route('guia-remitente/:idComprobante', 'admin.guiaRemision.guia-remitente-comprobante', { requiresAuth: true, titulo: 'Guia de Remisión' }, 'admin/guiaRemision/GuiaRemitente', { isComprobante: true }),
                      route('guia-remitente/:idCotizacion', 'admin.guiaRemision.guia-remitente-cotizacion', { requiresAuth: true, titulo: 'Guia de Remisión' }, 'admin/guiaRemision/GuiaRemitente', { isCotizacion: true }),
                      route('editar-guia/:idEdit', 'admin.guiaRemision.editar-guia', { requiresAuth: true, titulo: 'Editar Guia de Remisión' }, 'admin/guiaRemision/GuiaRemitente', { isEdit: true }),
                      route('editar-guia-transporte/:idEdit','admin.guiaRemision.editar-guia-transporte', {requiresAuth: true, titulo: 'Editar Guia de Remisión Transportista'}, 'admin/guiaRemision/GuiaTransportista', {isEdit: true})
                    ]
              ),   
            routeWithChildren( 'cotizaciones', 'admin.cotizaciones', {requiresAuth: true, titulo: 'Cotizaciones'}, 'admin/Cotizaciones', '/admin/cotizaciones/ver-cotizaciones',
                    [
                      route('ver-cotizaciones', 'admin.cotizaciones.ver-cotizaciones', {requiresAuth: true, titulo: 'Cotizaciones'}, 'admin/cotizaciones/verCotizaciones'),
                      route('emitir-cotizacion','admin.cotizaciones.emitir-cotizacion', {requiresAuth: true, titulo: 'Emitir Cotización'}, 'admin/cotizaciones/EmitirCotizacion', {isEdit: false}),
                      route('editar-cotizacion/:idEdit', 'admin.cotizaciones.editar-cotizacion', {requiresAuth: true, titulo: 'Editar Cotización'}, 'admin/cotizaciones/EmitirCotizacion', {isEdit: true})  
                    ]
            ), 
            
            routeWithChildren('otros-comprobantes','admin.otrosComprobantes', {requiresAuth: true, titulo:'Otros documentos'}, 'admin/OtrosComprobantes','/admin/otros-comprobantes/ver',
              [
                route('ver','admin.otros-comprobantes.ver', {requiresAuth: true, titulo: 'Ver otros documentos'}, 'admin/otrosComprobantes/VerOtrosComprobantes'),
                route('retencion','admin.otros-comprobantes.retencion', {requiresAuth: true, titulo: 'Emitir Retención'}, 'admin/otrosComprobantes/Retenciones'),
                route('percepcion','admin.otros-comprobantes.percepcion', {requiresAuth: true, titulo: 'Emitir Percepción'}, 'admin/otrosComprobantes/Percepciones'),
                route('editar-retencion/:idEdit','admin.otros-comprobantes.editar-retencion', {requiresAuth: true, titulo: 'Editar retención electrónica'}, 'admin/otrosComprobantes/Retenciones', {isEdit: true}),
                route('editar-percepcion/:idEdit','admin.otros-comprobantes.editar-percepcion', {requiresAuth: true, titulo: 'Editar percepción electrónica'}, 'admin/otrosComprobantes/Percepciones', {isEdit: true}),
              ]
            ),

            routeWithChildren('solicitudes-excel','admin.solicitudesExcel',{requiresAuth: true, titulo: 'Solicitudes de descarga de Excels'}, 'admin/Solicitudes','/admin/solicitudes-excel/ver-excels',
              [
                route('ver-excels','admin.solicitudes-excel.ver-excels',{requiresAuth: true, titulo: 'Estados de excels'},'admin/solicitudes/VerSolicitudes')
              ]
            ),
            route('superadmin','admin.superadmin', {requiresAuth: true, titulo:'Administración de usuarios'}, 'admin/Sadmin'),
            route('grafica-venta','admin.grafica-venta', {requiresAuth: true, titulo:'Grafico de Ventas'}, 'admin/graficos/ChartVenta'),
            route('grafica-coti','admin.grafica-coti', {requiresAuth: true, titulo:'Grafico de Cotizaciones'}, 'admin/graficos/ChartCoti'),
            route('grafica-compras','admin.grafica-compras', {requiresAuth: true, titulo:'Grafico de Compras'}, 'admin/graficos/ChartCompras'),
            route('clientes', 'admin.clientes', { requiresAuth: true, titulo: 'Clientes' }, 'admin/Clientes'),
            route('direcciones', 'admin.direcciones', { requiresAuth: true, titulo: 'Direcciones' }, 'admin/Direcciones'),
            route('unidades','admin.unidades', {requiresAuth: true, titulo:'Unidades'}, 'admin/Unidades'),
            // route('atributos','admin.atributos', {requiresAuth: true, titulo:'AtributosProducts'}, 'admin/AtributosProducts'),
            route('productos','admin.productos', {requiresAuth: true, titulo:'Productos'}, 'admin/Productos'),

            route('compras','admin.compras', {requiresAuth: true, titulo:'Compras'}, 'admin/compras/Compras'),
            route('compras/agregar-compra','admin.agregar-compra', {requiresAuth: true, titulo:'Agregar compra'}, 'admin/agregarCompra/AgregarCompra'),
            route('compras/editar-compra/:id','admin.editar-compra', {requiresAuth: true, titulo:'Editar compra'}, 'admin/agregarCompra/AgregarCompra'),
            route('proveedores','admin.proveedores', {requiresAuth: true, titulo:'Proveedores'}, 'admin/proveedores/Proveedores'),

            route('productos/:id/editar','admin.productos.editar', {requiresAuth: true, titulo:'Editar producto'}, 'admin/EditarProducto'),
            route('percepciones','admin.percepciones', {requiresAuth: true, titulo:'Percepciones'}, 'admin/Percepciones'),
            route('retenciones','admin.retenciones', {requiresAuth: true, titulo:'Retenciones'}, 'admin/Retenciones'),
            route('usuarios','admin.usuarios', {requiresAuth: true, titulo:'Usuarios'}, 'admin/Usuarios'),
            route('usuarios/:id/editar','admin.usuarios.editar', {requiresAuth: true, titulo:'Editar usuario'}, 'admin/EditarUsuario'),
            route('datos-principales','admin.datos-principales', {requiresAuth: true, titulo:'Datos principales'}, 'admin/DatosPrincipales'),
            route('puntos-venta','admin.puntos-venta', {requiresAuth: true, titulo:'Puntos de venta'}, 'admin/PuntosVenta'),
            route('mis-emails','admin.mis-emails', {requiresAuth: true, titulo:'Mis Emails'}, 'admin/MisEmails'),
            route('mis-emails/:id/editar','admin.mis-emails.editar', {requiresAuth: true, titulo:'Editar Email'}, 'admin/EditarEmail'),
            route('puntos-venta/:id/editar','admin.puntos-venta.editar', {requiresAuth: true, titulo:'Editar punto de venta'}, 'admin/EditarPuntoVenta'),
            route('cambio-clave','admin.cambio-clave', {requiresAuth: true, titulo:'Cambio clave'}, 'admin/Cambio'),
            route('unidad-medida','admin.unidad-medida', {requiresAuth: true, titulo:'Unidad de medida'}, 'admin/UnidadMedida'),
            route('cuentas-bancarias','admin.cuentas-bancarias', {requiresAuth: true, titulo:'Cuentas Bancarias'}, 'admin/CuentasBancarias'),
          ]
        }
      ]

    },
    {
      path: '/login/:user?/:pass?',
      name: 'login',
      meta: {titulo : 'Iniciar sesión'},
      component:Login
    },
    {
      path: '/consulta-comprobantes/:ruc?',
      name: 'consulta.comprobantes',
      meta: {titulo : 'Consulta tus comprobantes'},
      component: Consulta,
    },

    {
      path: '*',
      redirect: '/',
    },


  ],
  linkActiveClass: "is-active customActiveLink",
  //mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
})

router.beforeEach((to, from, next) => {
  if(!Util.checkAuth() && to.meta.requiresAuth){
    next({name:'login'})
    return
  }

  window.document.documentElement.scrollTop = 0
  window.document.title = `${to.meta.titulo} - Certifakt`
  Vue.prototype.$eventBus.$emit('close-menu')


  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js